const DISMISS_UNTIL_KEY = 'vo2_pwa_install_dismiss_until';
const VISIT_COUNT_KEY = 'vo2_pwa_install_visit_count';

const DISMISS_DAYS = 7;

export function recordPwaVisit(): number {
  try {
    const next = Number(localStorage.getItem(VISIT_COUNT_KEY) ?? '0') + 1;
    localStorage.setItem(VISIT_COUNT_KEY, String(next));
    return next;
  } catch {
    return 1;
  }
}

export function isPwaInstallDismissed(): boolean {
  try {
    const until = Number(localStorage.getItem(DISMISS_UNTIL_KEY) ?? '0');
    return until > Date.now();
  } catch {
    return false;
  }
}

export function dismissPwaInstallPrompt(): void {
  try {
    const until = Date.now() + DISMISS_DAYS * 24 * 60 * 60 * 1000;
    localStorage.setItem(DISMISS_UNTIL_KEY, String(until));
  } catch {
    /* private mode */
  }
}
